import React from 'react';
import { Box, Paper, Typography, Button, Stack } from '@mui/material';
import Grid from '@mui/material/Grid';
import ButtonGroup from '@mui/material/ButtonGroup';
import { USysObjects, CurrentActiveServicePage } from '../utils/extensions/constantEx';
import { HomeContext } from '../utils/contexts/homeContext';

export default function ServiceFormHeader(props) {

    const {
        formMode, openedPage, isServiceClosed, formHeaderText,
        handleEditClick, handleSaveClick, handleCancelClick, handleCloseServiceClick, handleNurseChangeClick, handleOpenRenewServiceClick, handleNewPaymentClick
    } = props;

    const { homeState } = React.useContext(HomeContext);

    return (

        <Paper sx={{ zIndex: '900' }}>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="stretch"
            >
                <Grid size={3}>
                    <Typography variant="h5" sx={{ p: 2 }}>
                        {
                            formHeaderText
                        }
                    </Typography>
                </Grid>
                <Grid size={9}>
                    <Box sx={{ pr: 1, float: 'right', paddingTop: '14px' }}>
                        <Stack direction="row" spacing={2}>
                            {
                                openedPage === CurrentActiveServicePage.ViewPage &&
                                homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.PatientServicePayments && col.is_add_new) &&
                                <Button variant="contained" onClick={handleNewPaymentClick}>New Payment</Button>
                            }

                            <ButtonGroup variant="contained">
                                {/* {
                                    formMode === FormMode.ViewMode &&
                                    <Button variant="contained" color="error" onClick={handleDeleteServiceClick}>Delete</Button>
                                } */}
                                {
                                    homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.PatientServices && col.is_edit) &&
                                    openedPage === CurrentActiveServicePage.ViewPage && !isServiceClosed &&
                                    <Button variant="contained" onClick={handleCloseServiceClick}>Complete Service</Button>
                                }
                                {
                                    homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.PatientServices && col.is_edit) &&
                                    openedPage === CurrentActiveServicePage.ViewPage && !isServiceClosed &&
                                    <Button variant="contained" onClick={handleOpenRenewServiceClick}>Renew Service</Button>
                                }
                                {
                                    homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.PatientServices && col.is_edit) &&
                                    openedPage === CurrentActiveServicePage.ViewPage && !isServiceClosed &&
                                    <Button variant="contained" onClick={handleNurseChangeClick}>Change Nurse</Button>
                                }
                                {
                                    homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.PatientServices && col.is_edit) &&
                                    openedPage === CurrentActiveServicePage.ViewPage && !isServiceClosed &&
                                    <Button variant="contained" onClick={handleEditClick}>Edit</Button>
                                }
                                {
                                    (openedPage === CurrentActiveServicePage.EditPage || openedPage === CurrentActiveServicePage.NewPage
                                        || openedPage === CurrentActiveServicePage.ChangeNursePage
                                    ) && !isServiceClosed &&
                                    <Button variant="contained" onClick={handleSaveClick}>Save</Button>
                                }
                            </ButtonGroup>

                            {/* {
                                formMode === FormMode.ViewMode &&
                                <Button variant="contained" onClick={handleCloseServiceClick}>Complete Service</Button>
                            }
                            {
                                formMode === FormMode.ViewMode &&
                                <Button variant="contained" onClick={handleEditClick}>Edit</Button>
                            }
                            {
                                formMode !== FormMode.ViewMode &&
                                <Button variant="contained" onClick={handleSaveClick}>Save</Button>
                            } */}
                            <Button variant="outlined" onClick={handleCancelClick}>
                                {openedPage === CurrentActiveServicePage.EditPage || openedPage === CurrentActiveServicePage.NewPage
                                    || openedPage === CurrentActiveServicePage.ChangeNursePage ? 'Cancel' : 'Close'}
                            </Button>
                        </Stack>

                    </Box>
                </Grid>
            </Grid>
        </Paper>

    );
}